export default __webpack_public_path__ + "static/media/logo.b54d58f8.png";